import {Injectable} from '@angular/core';
import {Haptics, ImpactStyle} from '@capacitor/haptics';

@Injectable({
  providedIn: 'root'
})
export class HapticsImpactManagerService {

  /**
   * Impacto pesado
   *
   */
  public async hapticsImpactHeavy() {
    await Haptics.impact({style: ImpactStyle.Heavy}).catch(() => {
      console.error('Error: The Vibrate API is not implemented on the web');
    });
  };


  /**
   * Impacto medio
   *
   */
  public async hapticsImpactMedium() {
    await Haptics.impact({style: ImpactStyle.Medium}).catch(() => {
      console.error('Error: The Vibrate API is not implemented on the web');
    });
  }


  /**
   * Impacto ligero
   *
   */
  public async hapticsImpactLight() {
    await Haptics.impact({style: ImpactStyle.Light}).catch(() => {
      console.error('Error: The Vibrate API is not implemented on the web');
    });
  }


  /**
   * Vibración
   *
   */
  public async hapticsVibrate() {
    await Haptics.vibrate().catch(() => {
      console.error('Error: The Vibrate API is not implemented on the web');
    });
  }

}
